import {ACTION_CODE} from './_actionCode';
import {InvoiceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DOWNLOAD_INVOICE_BY_ID';

export async function downloadInvoiceById(userData: Record<string, any>, id: number) {
    try {
        LoggerService.logInfo('Action - downloadInvoiceById - Start');

        const downloadInvoiceByIdResult = await InvoiceService.downloadInvoiceById(userData, id);

        LoggerService.logInfo('Action - downloadInvoiceById - End - Success');

        return ResultModel.newSuccessResult(downloadInvoiceByIdResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - downloadInvoiceById - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors du téléchargement de la facture.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
